import React from "react";
import { Link as ScrollLink } from "react-scroll";

const BaseScrollLink = ScrollLink as unknown as React.ComponentType<any>;

export default BaseScrollLink;
